"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvContext = void 0;
const react_1 = require("react");
exports.EnvContext = (0, react_1.createContext)(null);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LWNvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvdmlkZXIvZW52LWNvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUNBQXNDO0FBSXpCLFFBQUEsVUFBVSxHQUFHLElBQUEscUJBQWEsRUFBb0IsSUFBSSxDQUFDLENBQUMifQ==